<script>
import HelpBar from '../Help/component.vue';
import NewsBar from '../News/Bar.vue';
import AccountBar from '../Account/component.vue';
import InfoBar from '../Info/Bar.vue';
import MessageBar from '../Message/Bar.vue';
import SettingBar from '../Setting/Bar.vue';
import SearchPanel from '../Search/SearchPanel.vue';

const el = document.querySelector('.mag-main');

export default {
  components: {
    HelpBar,
    NewsBar,
    AccountBar,
    MessageBar,
    InfoBar,
    SettingBar,
    SearchPanel,
  },
  props: {
    value: Boolean,
    title: String,
    module: Object,
  },
  data: () => ({
    open: '',
  }),
  methods: {
    close() {
      this.open = '';
    },
  },
  mounted() {
    if (el) el.addEventListener('click', this.close);
  },
  beforeDestroy() {
    if (el) el.removeEventListener('click', this.close);
  },
};
</script>
<template>
  <v-app-bar
    app
    clipped
    id="mag-template-header"
  >
    <v-app-bar-nav-icon @click.stop="$emit('input', !value)"></v-app-bar-nav-icon>

    <v-toolbar-title>{{ title }}</v-toolbar-title>

    <v-spacer></v-spacer>

    <SearchPanel></SearchPanel>

    <MessageBar
      :value="open === 'message'"
      @input="open = $event ? 'message' : ''"
      :module="module.message"
    />

    <NewsBar
      :value="open === 'news'"
      @input="open = $event ? 'news' : ''"
      :module="module.news"
    />

    <InfoBar
      :value="open === 'info'"
      @input="open = $event ? 'info' : ''"
      :module="module.info"
    />

    <AccountBar
      :value="open === 'account'"
      @input="open = $event ? 'account' : ''"
      :module="module.account"
    />

    <SettingBar
      :module="module.setting"
    />

    <HelpBar
      :value="open === 'help'"
      @input="open = $event ? 'help' : ''"
      :module="module.help"
    />
  </v-app-bar>
</template>
<style lang="scss">
#mag-template-header{
  a.v-btn{
    text-decoration: none;
  }
}
</style>
